import { Component, Input } from '@angular/core';
import { ClassToggleService, HeaderComponent, SidebarModule } from '@coreui/angular';
import {EventManager} from "../../../../shared/services/broadcast.service";
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ChatbotService } from '../../../../shared/services/chatbot.service';


@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
})
export class DefaultHeaderComponent extends HeaderComponent {

  @Input() sidebarId: string = "sidebar";
  langKey: string | null = 'vi';

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)
  isShowLang: boolean = true;

  notifications: any[] = [];
  unreadCount: number = 0;

  constructor(
    private classToggler: ClassToggleService,
    private eventManager: EventManager,
    private router: Router,
    private http: HttpClient,
    private chatbotService: ChatbotService
  ) {
    super();
    this.eventManager.subscribe('changeLanguage', (lang: any) => {
      this.langKey = lang.content;
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkURL();
      }
    });
  }

  ngOnInit(): void {
    this.langKey = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
    this.fetchNotifications();
  }

  fetchNotifications(): void {
    this.http.get<any>('/assets/mock-notifications.json').subscribe((data: any) => {
      if (data.data && Array.isArray(data.data)) {
        this.notifications = data.data;
        const lastReadTime = localStorage.getItem('lastNotificationReadTime');
        if (lastReadTime) {
          const readTimestamp = new Date(lastReadTime).getTime();
          this.unreadCount = data.data.filter((item: any) => {
            return new Date(item.timestamp).getTime() > readTimestamp;
          }).length;
        } else {
          this.unreadCount = data.data.length;
        }
      }
    });
  }

  markAsRead(): void {
    localStorage.setItem('lastNotificationReadTime', new Date().toISOString());
    const lastReadTime = localStorage.getItem('lastNotificationReadTime');
    if (lastReadTime && this.notifications) {
      const readTimestamp = new Date(lastReadTime).getTime();
      this.unreadCount = this.notifications.filter((item: any) => {
        return new Date(item.timestamp).getTime() > readTimestamp;
      }).length;
    } else {
      this.unreadCount = 0;
    }
  }

  viewAllNotifications(): void {
    this.markAsRead();
    this.router.navigate(['/notification/notification-list']);
  }

  checkURL(): void {
    const urlParts = window.location.href.split('/');
    if (urlParts[4] && urlParts[4].includes('global')) {
      this.isShowLang = false;
    }
    else{
      this.isShowLang = true;
    }
  }

  // Opens this page's assistant panel; pages without one go to the full chatbot page
  navigateToChatbot(): void {
    if (!this.chatbotService.openHostAssistant()) {
      this.router.navigate(['/chatbot/icd-10']);
    }
  }
}
